export type AddContactToResourceTranslation = {
  button: {
    addAndAssign: string;
    assign: string;
  };
  dialog: {
    button: {
      close: string;
    };
    title: string;
  };
};

export const addContactToResourceTranslation: AddContactToResourceTranslation = {
  button: {
    addAndAssign: 'Utwórz nowy kontakt',
    assign: 'Przypisz istniejący kontakt',
  },
  dialog: {
    button: {
      close: 'Zamknij',
    },
    title: 'Dodaj kontakt',
  },
};
